import { render, staticRenderFns } from "./sheet-detials.vue?vue&type=template&id=7572a170&scoped=true"
import script from "./sheet-detials.vue?vue&type=script&lang=js"
export * from "./sheet-detials.vue?vue&type=script&lang=js"
import style0 from "./sheet-detials.vue?vue&type=style&index=0&id=7572a170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572a170",
  null
  
)

export default component.exports